import { getSites } from 'apis/operator_site/siteApi';
import { SelectOption } from 'components/organisms/EditCompressionsResourceDataModal';
import AdminOperatorItemsTable from 'components/organisms/AdminOperatorItemsTable/AdminOperatorItemsTable';
import { AdminTemplate } from 'components/templates/AdminTemplate';
import OperatorManagementTemplate from 'components/templates/OperatorManagement';
import { getActive } from 'pages/AdminOperatorListManagement/AdminOperatorListManagement';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Path } from 'routes';
import { OperatorType } from 'util/Enums';
import { useQuery } from 'util/queryParams';
import { CustomizeItemBreadcrumbs } from 'util/Types';

const AdminOperatorItems = () => {
  const { t } = useTranslation();
  const query = useQuery();
  const { operatorId } = useParams<{ operatorId: string }>();

  const type = query.get('type');
  const [breadcrumb, setBreadcrumb] = useState<CustomizeItemBreadcrumbs>({
    operatorName: '-',
  });

  const [siteOptions, setSiteOptions] = useState<SelectOption[]>([]);
  const [unSettingItemCount, setUnSettingItemCount] = useState(0);

  const fetchSites = () => {
    getSites({
      params: { operatorId, type: OperatorType.Emissions },
      successCallback: (data) => {
        if (data) {
          setBreadcrumb((prev) => ({
            ...prev,
            operatorName: data.operatorName,
          }));
          setSiteOptions([
            { value: '', label: t('setting_operator_name.all_sites') },
            ...data.sites.map((item) => ({ value: item.id, label: item.id })),
          ]);
        }
      },
    });
  };

  useEffect(() => {
    fetchSites();
  }, [operatorId]);

  return (
    <AdminTemplate
      h1={''}
      active={getActive(type as OperatorType)}
      breadcrumb={[
        {
          label: getActive(type as OperatorType) || '-',
          href: `${Path.adminOperatorListManagement}${window.location.search}`,
        },
        { label: breadcrumb.operatorName || '-' },
      ]}
    >
      <OperatorManagementTemplate itemCount={unSettingItemCount}>
        <h1 className="admin-contents__main__header__title">
          {t('setting_operator_name.heading')}
        </h1>
        <AdminOperatorItemsTable
          siteOptions={siteOptions}
          onTotalUnsettingItemsChange={setUnSettingItemCount}
        />
      </OperatorManagementTemplate>
    </AdminTemplate>
  );
};

export default AdminOperatorItems;
